export default __webpack_public_path__ + "bf78ecb0fee23629f2d976af9751db01.png";